import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Category, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";

const UserGroupRoleDeptWithPersonModal = ({
  mode,
  handleCloseClick,
  editData,
}) => {
  const [loading, setLoading] = useState(false);
  const [person, setPerson] = useState([]);
  const [userGroupRoleDept, setGroupRoleDept] = useState([]);
  const [notificationType, setNotificationType] = useState([]);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const roleLink = masterAPI["usergroupwithroleanddepartment"].link;
    await axiosPrivate
      .get(`${roleLink}`)
      .then((res) => {
        setLoading(false);
        setGroupRoleDept(res.data.result);
      })
      .catch((e) => {
        setGroupRoleDept([]);
        setLoading(false);
        console.log(e, "GroupRoleDept");
      });

    const link = masterAPI["person"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setPerson(res.data.result);
      })
      .catch((e) => {
        setPerson([]);
        setLoading(false);
        console.log(e, "setPerson");
      });
    const linkDepart = masterAPI["selectList"].notificationType;
    await axiosPrivate
      .get(`${linkDepart}`)
      .then((res) => {
        setLoading(false);
        setNotificationType(res.data);
        console.log(res.data, "type");
      })
      .catch((e) => {
        setNotificationType([]);
        setLoading(false);
        console.log(e, "type");
      });
  };

  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
    userGroupRoleDeptId: mode === "Edit" ? editData.userGroupRoleDeptId : "",
    personId: mode === "Edit" ? editData.personId : "",
    userGroupId: mode === "Edit" ? editData.userGroupId : "",
    notificationtype: mode === "Edit" ? editData.notificationtype : "",
  };
  console.log("editData", editData);

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["usergrouproledeptwithperson"].create;
    const updateLink = masterAPI["usergrouproledeptwithperson"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, value)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "createAC");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateAC");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? "Update User Group with role and department mapping"
            : "New User Group with role and department mapping"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  User Group Role & Department
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={userGroupRoleDept.length === 0}
                  options={userGroupRoleDept}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.userGroupWithRoleDepartmentName
                  }
                  value={
                    userGroupRoleDept.find(
                      (p) => p.id === values.userGroupRoleDeptId
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("userGroupRoleDeptId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="userGroupRoleDeptId"
                      placeholder="Select User Group Role Department"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={person.length === 0}
                  options={person}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.personName}
                  value={person.find((p) => p.id === values.personId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("personId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="personId"
                      placeholder="Select Person"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Type
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notificationType.length === 0}
                  options={notificationType}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text}
                  value={ notificationType.find((p) => p.value === values.notificationtype) || null }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("departmentId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="departmentId"
                      placeholder="Select Department"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default UserGroupRoleDeptWithPersonModal;
